package playground.gradient

import androidx.compose.ui.graphics.Color
import util.lerp
import kotlin.math.abs


fun generateInBetweenColor(
    start: Color,
    end: Color,
    lerp: Float = .5f
): Color {

    val startHSV = start.rgbToHsv()
    val endHSV = end.rgbToHsv()

    return HSV(
        hue = lerp(
            startHSV.hue, endHSV.hue, lerp
        ),
        saturation = lerp(
            startHSV.saturation, endHSV.saturation, lerp
        ),
        value = lerp(
            startHSV.value, endHSV.value, lerp
        )
    )
        .hsvToRgb().toColor()


}


data class HSV(val hue: Float, val saturation: Float, val value: Float)

fun Color.rgbToHsv(): HSV {
    val hsv: HSV

    val rf = red
    val gf = green
    val bf = blue

    val cmax = maxOf(rf, gf, bf)
    val cmin = minOf(rf, gf, bf)
    val delta = cmax - cmin

    // Calculate Hue
    println("fake = ${((0f - 1f) / 1f) modulo  6}")
    println("fake = ${60f * (((0f - 1f) / 1f) modulo 6)}")
    val hue: Float = when {
        delta == 0.0f -> 0.0f
        cmax == rf -> 60.0f * (((gf - bf) / delta) modulo 6)
        cmax == gf -> 60.0f * (((bf - rf) / delta) + 2)
        else -> 60.0f * (((rf - gf) / delta) + 4)
    }

    // Calculate Saturation
    val saturation: Float = if (cmax == 0.0f) 0.0f else delta / cmax

    // Calculate Value
    val value: Float = cmax

    hsv = HSV(hue, saturation, value)

    return hsv
}

data class RGB(val red: Float, val green: Float, val blue: Float)

fun RGB.toColor(): Color =
    Color(
        red = red.coerceIn(0f..255f) / 255f,
        green = green.coerceIn(0f..255f) / 255f,
        blue = blue.coerceIn(0f..255f) / 255f
    )


fun HSV.hsvToRgb(): RGB {
    val c = value * saturation
    val x = c * (1 - abs(((hue / 60) modulo 2) - 1))
    val m = value - c

    val rf: Float
    val gf: Float
    val bf: Float

    when {
        hue >= 0 && hue < 60 -> {
            rf = c
            gf = x
            bf = 0.0f
        }

        hue >= 60 && hue < 120 -> {
            rf = x
            gf = c
            bf = 0.0f
        }

        hue >= 120 && hue < 180 -> {
            rf = 0.0f
            gf = c
            bf = x
        }

        hue >= 180 && hue < 240 -> {
            rf = 0.0f
            gf = x
            bf = c
        }

        hue >= 240 && hue < 300 -> {
            rf = x
            gf = 0.0f
            bf = c
        }

        else -> {
            rf = c
            gf = 0.0f
            bf = x
        }
    }

    val r = ((rf + m) * 255)
    val g = ((gf + m) * 255)
    val b = ((bf + m) * 255)


    return RGB(r, g, b)
}

//fun Color.toHex(): String {
//    return String.format("0xFF%02X%02X%02X", (red * 255).toInt(), (green * 255).toInt(), (blue * 255).toInt())
//}
fun Color.toHex(): String {
    val hexRed = ((red * 255).toInt()).coerceIn(0, 255).toString(16).padStart(2, '0')
    val hexGreen = ((green * 255).toInt()).coerceIn(0, 255).toString(16).padStart(2, '0')
    val hexBlue = ((blue * 255).toInt()).coerceIn(0, 255).toString(16).padStart(2, '0')
    return "0xFF$hexRed$hexGreen$hexBlue"
}


infix fun Float.modulo(other: Float): Float {
    val x = rem(other)
    return if (x < 0) x + other else x
//    return rem(other)
}

infix fun Float.modulo(other: Int): Float {
    return modulo(other.toFloat())
}